import { capturePostHogEvent } from './posthogClient';

export function captureDescriptorRequestView() {
  try {
    capturePostHogEvent('engage-descriptor-request-view');
  } catch {
    // Analytics must not break the descriptor queue.
  }
}

export function captureDescriptorRequestApprove(requestId) {
  try {
    capturePostHogEvent('engage-descriptor-request-approve', { requestId });
  } catch {
    // Analytics must not block approval.
  }
}

export function captureDescriptorRequestDecline(requestId) {
  try {
    capturePostHogEvent('engage-descriptor-request-decline', { requestId });
  } catch {
    // Analytics must not block a decline.
  }
}

export function captureDescriptorRequestDuplicate(requestId) {
  try {
    capturePostHogEvent('engage-descriptor-request-duplicate', { requestId });
  } catch {
    // Analytics must not hide the existing descriptor.
  }
}
